import { useState, useEffect } from 'react';

function TagsInput({ value, onChange }) {
  const [tags, setTags] = useState([]);

  useEffect(() => {
    if (value) {
      setTags(value);
    }
  }, [value]);

  function removeTag(index) {
    const updatedTags = tags.filter((_, i) => i !== index);
    setTags(updatedTags);
    onChange(updatedTags);
  }

  return (
    <div className="tags-input-container">
      {tags.map((tag, index) => (
        <div className="tag-item" key={index}>
          <span className="tag-font">{tag}</span>
          <span className="close" onClick={() => removeTag(index)}>
            &times;
          </span>
        </div>
      ))}
    </div>
  );
}

export default TagsInput;


//import { useState, useEffect } from 'react';
//
//function TagsInput({ value, onChange }) {
//  const [tags, setTags] = useState([]);
//
//  useEffect(() => {
//    if (value) {
//      setTags(value);
//    }
//  }, [value]);
//
//  function handleKeyDown(e) {
//    if (e.key !== 'Enter') return;
//    const inputValue = e.target.value.trim();
//    if (inputValue === '') return;
//    const updatedTags = [...tags, inputValue];
//    setTags(updatedTags);
//    onChange(updatedTags);
//    e.target.value = '';
//  }
//
//  function removeTag(index) {
//    const updatedTags = tags.filter((_, i) => i !== index);
//    setTags(updatedTags);
//    onChange(updatedTags);
//  }
//
//  return (
//    <div className="tags-input-container">
//      {tags.map((tag, index) => (
//        <div className="tag-item" key={index}>
//          <span className="tag-font">{tag}</span>
//          <span className="close" onClick={() => removeTag(index)}>
//            &times;
//          </span>
//        </div>
//      ))}
//      <input
//        onKeyDown={handleKeyDown}
//        type="text"
//        className="tags-input"
//        placeholder="Add more"
//      />
//    </div>
//  );
//}
//
//export default TagsInput;
